import React, { useEffect } from "react";
import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import { deleteNews, detailNews, listNews } from "../redux/actions/newsAction";
import PageTitle from "../components/PageTitle";
import moment from "moment";
import { Link } from "react-router-dom";

const NewsScreen = () => {
  const dispatch = useDispatch();
  const listNewsState = useSelector((state) => state.listNews);
  const { news } = listNewsState;
  const newsDeleteState = useSelector((state) => state.newsDelete);
  const { success } = newsDeleteState;
  useEffect(() => {
    dispatch(listNews());
  }, [success]);
  return (
    <Layout>
      <PageTitle title="News" button="Add News" link="/add-news" />
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3">List of News</h4>

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Link</th>
                  <th>Created At</th>
                  <th>Description</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {news &&
                  news.map((value) => (
                    <tr>
                      <td>{value.title}</td>
                      <td>
                        <a href={value.link} target="_blank">
                          Read More
                        </a>
                      </td>

                      <td>{moment(value.createdAt).format("MMMM Do YYYY")}</td>

                      <td style={{ width: "300px" }}>{value.description}</td>
                      <td style={{ width: "100px" }}>
                        <Link
                          to={`/edit-news/${value.uuid}`}
                          onClick={() => dispatch(detailNews(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </Link>
                        <button
                          style={{
                            marginLeft: "5px",
                            backgroundColor: "red",
                            color: "#fff",
                          }}
                          to={`/edit-news/${value.uuid}`}
                          onClick={() => dispatch(deleteNews(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NewsScreen;
